module.exports = __webpack_public_path__ + "img/2.50fd4c4f.jpg";